import { connect } from "react-redux";
import { getMyTicketsForTournament, getSession } from "../selectors";
import TournamentBuyBox from "../components/tournament-buy-box";

import { sessionShowLogin } from "../actions/session";
import { tournamentEnter } from "../actions/tournament";

function select(state, props) {
  return {
    myTickets: getMyTicketsForTournament(state, props),
    session: getSession(state, props),
  };
}

export default connect(select, { sessionShowLogin, tournamentEnter })(TournamentBuyBox);
